export default __webpack_public_path__ + "static/adiel-370be381f55ac9762263867fd2288d2d.jpg";